module.exports = __webpack_public_path__ + "static/portfolio3a-536057e790dc79c9c22f018feeb76c72.jpg";